import React from 'react';
import {Multiselect} from "multiselect-react-dropdown";

export default class MultiSelectFilter extends React.Component {
    constructor(props) {
        super(props);
        this.filter = this.filter.bind(this);
        this.getValue = this.getValue.bind(this);
        this.state = {
            selectedValues: props.selectedValues ? props.selectedValues : []
        }
    }
    componentDidMount() {
        if(this.props.selectedValues){
            this.props.onFilter(this.getValue())
        }

    }

    getValue() {
        return this.state?.selectedValues.map(obj => obj.value);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedValues.length !== this.state.selectedValues.length) this.props.onFilter(this.getValue());
    }

    filter(values) {
        this.setState({selectedValues: values});
    }

    resetFilter() {
        this.setState({selectedValues: []})
    }

    render() {
        return [
            <div onClick={(e) => e?.stopPropagation()}>
            <Multiselect
            key={this.props.column.dataField}
            options={this.props.options}
            selectedValues={this.state.selectedValues}
            style={{
                chips: {visibility: 'hidden', position: 'absolute'},
                optionContainer: {zIndex: 10000, background: 'white', display: 'inline-block', minWidth: 118, fontWeight:'normal'},
                searchBox: {fontSize: '9px', height: 22},
                inputField: {height: 8,maxWidth:44}
            }}
            showCheckbox
            placeholder={this.state.selectedValues?.length > 0 ? `${this.state.selectedValues.length} Selected` : 'All Values'}
            closeOnSelect={true}
            showArrow={true}
            hidePlaceholder={false}
            avoidHighlightFirstOption={true}
            onSelect={(selectedList) => {this.filter(selectedList)}}
            onRemove={(selectedList) => this.filter(selectedList)}
            displayValue="label"/>
            </div>
    ];
    }
}
